<template>
    <div class="product__item product__item--accordion" :index="index" ref="row">
        <input :id="'domain_' + index" type="radio" name="domain" :checked="checked" @change="scrollToElement" />
        <label :for="'domain_' + index" class="product__item-header | u-cursor-pointer">
            <span>
                {{ domain.domain }}
            </span>
        </label>

        <div class="product__item-body">
            <vps-plans :domain="domain" />
        </div>
    </div>
</template>

<script>
    import VpsPlans from './VpsPlans.vue';
    import accordionMixin from '../../mixins/accordion';

    export default {
        props: {
            domain: Object,
            index: Number
        },
        mixins: [accordionMixin],
        components: {
            VpsPlans
        }
    };
</script>
